import { render } from "./eghmatgah.vue?vue&type=template&id=509e4949"
import script from "./eghmatgah.vue?vue&type=script&lang=js"
export * from "./eghmatgah.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pamenar-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__